import { OdataFieldThreeValueOperator } from './OdataFieldThreeValueOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldOperatorReplace extends OdataFieldThreeValueOperator {
  constructor(field: IOdataField, match: IOdataField, replaceWith: IOdataField) {
    super(field, match, replaceWith, 'replace');
  }
}
